import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { LandingPage } from './pages/LandingPage';

const APP_STORE_URL = 'https://apps.apple.com/app/id6776450939';

function AppStoreRedirect() {
  React.useEffect(() => {
    window.location.replace(APP_STORE_URL);
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/download" element={<AppStoreRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
